import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const session = getUserSession()
    const profileFilter = chooseProfileFilter()
    
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const { id } = useParams();
    
    const hiddenValues = {}


    const path = '/pcontasaccountspayable/';
    const paths = {
        endpointSave: config.endpoints.backend + 'pcontasaccountspayable/save',
        endpointGetById: config.endpoints.backend + 'pcontasaccountspayable/getById',
        endpointGetAllAccountingProjects: config.endpoints.backend + 'accountingprojects/getall',
        endpointGetAllPcontasSubCategories: config.endpoints.backend + 'pcontassubcategories/getall',
        endpointGetAllPcontasDocumentTypes: config.endpoints.backend + 'pcontasdocumenttypes/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Conta a pagar",
        labelTitleEdit: "Editar Conta a pagar",
        labelTitleView: 'Visualizar Conta a pagar'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_accounting_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAccountingProjects,
                        label: 'despro',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_pconta_sub_category_id',
                    type: 'select',
                    label: 'Sub Categoria',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPcontasSubCategories,
                        label: 'description',
                        value: 'id',
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_pconta_document_type_id',
                    type: 'select',
                    label: 'Tipo de Documento',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPcontasDocumentTypes,
                        label: 'description',
                        value: 'id',
                    },
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'issue_date',
                    type: 'date',
                    label: 'Data de emissão',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
                {
                    name: 'maturity_date',
                    type: 'date',
                    label: 'Data de Vencimento',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
                {
                    name: 'payment_date',
                    type: 'date',
                    label: 'Data de Pagamento',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
                {
                    name: 'competence_date',
                    type: 'date',
                    label: 'Data de Competencia',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
                {
                    name: 'payment_description',
                    type: 'text',
                    label: 'Descrição do Pagamento',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_value',
                    type: 'decimal',
                    label: 'Valor',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_gross_value',
                    type: 'decimal',
                    label: 'Valor Bruto',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_discount',
                    type: 'decimal',
                    label: 'Desconto',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_interest',
                    type: 'decimal',
                    label: 'Juros',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'amount_paid',
                    type: 'decimal',
                    label: 'Total Pago',
                    validations: {
                        required: false,
                    },
                    columnSize: 12
                },
                {
                    name: 'partion',
                    type: 'integer',
                    label: 'Parcela',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
                {
                    name: 'total_partion',
                    type: 'integer',
                    label: 'Total de Parcelas',
                    validations: {
                        required: false,
                    },
                    columnSize: 6
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
